import { gql } from 'apollo-angular';

export const GET_HEADER_BLOCK = gql`
  query GetHeaderBlock {
    headerBlockCollection(limit: 1) {
      items {
        menuText
        logo {
          url
          description
          title
        }
      }
    }
  }
`;
